import { MouseEventHandler } from 'react';
import { NavLink } from 'react-router-dom';

const strings = {
  title: 'Ozodso‘z',
  menu: {
    about: 'Лойиҳа ҳақида',
    sendData: 'Хабар йўлланг',
    share: 'Улашинг ',
  },
  searchPlaceholder: 'Кісі есімін теріңіз',

  footer: {
    followUs: 'Ижтимоий тармоқлар',
    copyright: 'Озодлик радиоси © 2024 RFE/RL, Inc. | Барча ҳуқуқлар ҳимояланган',
    contentTitle: 'Озодлик ҳақида',
    content: `Озодлик радиоси матбуот эркинлиги тақиқланган ёки чекланган мамлакатларда кўпфикрлилик, демократия ва фуқаролик жамияти қадриятларига диққат қаратади. Озодлик контенти цензура қилинмаган янгилик, маълумотлар ва турли томонлар нуқтаи назарини акс эттирувчи таҳлил ва тадқиқотлардан иборат.`,
    creatorsTitle: 'Лойиҳа муаллифи',
    creators: (
      <p>
        <strong>Муаллиф:</strong> Озодлик радиоси
        <br />
        <strong>Дизайн:</strong> Pangea Digital Dataviz team
      </p>
    ),
  },

  home: {
    intro: (onClick: MouseEventHandler<HTMLAnchorElement>) => (
      <p>
        Бу Шавкат Мирзиёев президентлиги даврида қамоққа ташланган ва таъқиб қилинган журналист
        ҳамда блогерларга бағишланган махсус лойиҳа.
      </p>
    ),
    detailButton: 'Мақолани ўқиш',
    listTitle: 'Барчаси',
    noResults: 'Бу бўлимда ҳеч ким йўқ',
    allVictims: 'Барчаси',
    updated: 'Жаңартылған күні:',
  },
  search: {
    title: 'Қидириш',
    description: (search: string) => (
      <p>
        Нима излаяпсиз: <em>{search}</em>
      </p>
    ),
    listTitle: 'Натижа',
    noResults: 'Табылмады',
  },
  sendData: {
    title: 'Қўшимча маълумотингиз борми?',
    content: (
      <p>
        Шавкат Мирзиёев ҳокимиятга келгач ўзбекистонликларга кўпроқ сўз эркинлигини ваъда қилди.
        Маҳаллий матбуот жонланди, ижтимоий муаммолар муҳокамага олиб чиқилди. Ўзбекистон халқаро
        матбуот эркинлиги рейтингида бир неча поғона юқорилади. Аммо орадан кўп ўтмай, блогер,
        журналист ва тармоқ фаолларига нисбатан босимлар кучайди. Президентни ҳақорат қилгани учун
        10 дан ортиқ одам қамоққа ташланди. Каримов давридаги каби қўрқув муҳити ҳақида қайтди.
        Озодлик Мирзиёев президентлиги даврида ҳибсга олинган, қамоққа ташланган ва босимга учраган
        100 дан ортиқ журналист, блогер ва фаолларнинг ишини ҳужжатлаштирди. Агар сиз озод сўз учун
        жазоланган ёки босимга учраган бўлсангиз, Озодликка хабар беринг. Лойиҳа мунтазам янгилаб
        борилади.
      </p>
    ),
    subtitle: 'Қаңтар құрбаны бойынша мәлімет жіберу',
    globalLeaks: 'Аноним түрде жолдау',
  },
  profile: {
    judgement: 'Жазо',
    accusation: 'Айблов',
    persecution: 'Таъқиб',
    prohibition: 'Тақиқ',
    exileBan: 'Қувғин',
    work: 'Нашр',
    occupation: 'Фаолияти',
    detainedTime: 'Ҳодиса вақти',
    prisonTerm: 'Қамоқ муддати',
    releasedTime: 'Қамоқдан чиққан вақти',
    pressure: 'Тазйиқ',
    internationalReaction: 'Халқаро реакция',
    missingData: 'Маълумот йўқ',

    dateOfBirth: 'Туған күні:',
    ageOfDeath: 'Қаза тапқандағы жасы:',
    dateOfDeath: 'Қайтқан күні:',
    placeOfDeath: 'Қаза тапқан жері:',
    placeOfResidence: 'Тұрғылықты жері:',
    //occupation: 'Қатысушының статусы:',
    share: 'Тармоқларда улашиш',
    relatedVictims: 'Осы кісі туралы парақшаны бөлісу:',
    sendData: 'Қўшимча маълумотингиз борми?',
    source: 'Дереккөз',
    informationConfirmed: 'Құжатпен расталды',
    waitingForConfirmation: 'Бірнеше дереккөзден хабар түсті, құжаттау жүріп жатыр',
  },
};

export default strings;
